import * as React from 'react'

export default () => <div id="not-found">
  <p>
  404
  </p>
  <p>
  Not Found
  </p>
</div>